import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerDiameterListItem = (props) => {
    const { visualizerRadiusFactor, updateVisualizerSettings, maxRadiusFactor } = props;
    
    const onDiameterChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ radiusFactor: value });
    };
    
    return (
        <SliderListItem
            title='Diameter'
            value={visualizerRadiusFactor}
            displayMultiplier={0.5}
            min={0}
            max={maxRadiusFactor / 2}
            step={1}
            onValueChange={onDiameterChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { radiusFactor: visualizerRadiusFactor } = state.createPreview.present.videoSettings.visualizer;
    const { maxRadiusFactor } = state.create.maxValues;

    return { 
        visualizerRadiusFactor,
        maxRadiusFactor
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDiameterListItem);